import { EntityOverTimeProvider } from '@internal/backstage-plugin-common-library-react';
import { EngineeringInsightsPage } from '@internal/backstage-plugin-engineering-insights';
import {
  TeamScoreCard,
  ScorecardOverview,
  ScorecardDataProvider,
} from '@internal/backstage-plugin-scorecard-common-react';
import { EntityTeamPullRequestsContent } from '@internal/plugin-github-pull-requests-board';
import { LandingPageContent } from '@internal/plugin-landing-page';
import {
  EntityGrafanaAlertsCard,
  EntityGrafanaDashboardsCard,
  isAlertSelectorAvailable,
  isDashboardSelectorAvailable,
} from '@k-phoen/backstage-plugin-grafana';
import React from 'react';

import { Entity, RELATION_PARENT_OF } from '@backstage/catalog-model';
import { EntityLayout, EntitySwitch } from '@backstage/plugin-catalog';

import { Grid } from '@material-ui/core';

import { AnalyticsWrapper } from '../Components/AnalyticsWrapper';
import { GroupOverviewCard } from '../Components/GroupOverviewCard';
import { TeamOperationalExcellence } from '../Components/TeamOperationalExcellence';
import { ActionContent, EntityWarningContent } from '../Content';
import { isLandingPageEnabled } from '../entityUtils';

const isTeam = (entity: Entity) =>
  !entity?.relations?.find(item => item.type === RELATION_PARENT_OF);

const isEnabledForTeam = (entity: Entity) =>
  !isLandingPageEnabled(entity) && isTeam(entity);

const isTagSelectorAvailable = (entity: Entity) =>
  Boolean(isDashboardSelectorAvailable(entity));

const CompactOverviewLayout = () => {
  return (
    <Grid container spacing={2} alignItems="stretch">
      <EntityWarningContent />
      {ActionContent}

      <Grid item xs={12} md={12}>
        <GroupOverviewCard />
      </Grid>

      <Grid item xs={12} md={8}>
        <TeamOperationalExcellence />
      </Grid>

      <Grid item xs={12} md={4}>
        <ScorecardDataProvider>
          <ScorecardOverview />
        </ScorecardDataProvider>
      </Grid>
    </Grid>
  );
};

export const GroupPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Landing Page" if={isLandingPageEnabled}>
      <LandingPageContent />
    </EntityLayout.Route>

    <EntityLayout.Route path="/overview" title="Overview">
      <CompactOverviewLayout />
    </EntityLayout.Route>

    <EntityLayout.Route
      path="/dashboard"
      title="Grafana Dashboard"
      if={isTagSelectorAvailable || isAlertSelectorAvailable}
    >
      <Grid container spacing={3}>
        <EntitySwitch>
          <EntitySwitch.Case if={isTagSelectorAvailable}>
            <Grid item sm={6}>
              <EntityGrafanaDashboardsCard />
            </Grid>
          </EntitySwitch.Case>
        </EntitySwitch>

        <EntitySwitch>
          <EntitySwitch.Case if={isAlertSelectorAvailable}>
            <Grid item sm={6}>
              <EntityGrafanaAlertsCard />
            </Grid>
          </EntitySwitch.Case>
        </EntitySwitch>
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route
      path="/pull-requests"
      title="Pull Requests"
      if={isEnabledForTeam}
    >
      <EntityTeamPullRequestsContent />
    </EntityLayout.Route>

    <EntityLayout.Route
      path="/engineering-insights"
      title="Engineering Insights"
    >
      <Grid item sm={12}>
        <EngineeringInsightsPage />
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/scorecards" title="Scorecards">
      <Grid item sm={12}>
        <AnalyticsWrapper pluginId="scorecard">
          <EntityOverTimeProvider showDailyAggregation syncToUrl>
            <TeamScoreCard />
          </EntityOverTimeProvider>
        </AnalyticsWrapper>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
